import * as marietta from '../../..';
import { Dialog } from '../../../core/view';
import { LiDARData } from '../../../network/LiDARData'
import Main from '../../../../main';

/**
 * パフォーマンス・テストの準備中表示
 */
export class performanceDialogLoader extends Dialog {
  constructor(draggable: boolean) {
    super(draggable);

    let id: string; let title: string; let
      contents: string;

    // ダイアログのコンテンツ生成
    id = 'performanceDialogLoader';
    // タイトル
    switch (marietta.webcad.WebCADGlobal.language) {
      case 'en': title = '<span class="loading">Performance Analyse</span>'; break;
      default: title = '<span class="loading">パフォーマンス分析</span>'; break;
    }
    contents = '<div class="performanceLoading"> ご使用の環境の動作快適度チェック中です。<div>まもなく表示されます';
    contents += '</div></div>';

    this.createDialog(id, title, contents);
    // お掃除
    id = null;
    title = null;
    contents = null;
  }
}
/*
 * Classハンドルのパフォーマンスチェック表示。
 * パフォーマンスチェックの表示/非表示を処理します。
*/
export class performanceDialog extends Dialog {
    // パフォーマンスの表示/非表示のフラグ
    public _showPerformanceFlag: boolean = false;

    // ブラウザのローカルストレージに使用
    public _storage: any;

    /**
     * コンストラクタ
    */
    constructor(draggable: boolean) {
      super(draggable);
      this._storage = localStorage;

      let id: string; let title: string; let contents: string; let
        footer: string;

      // ダイアログのコンテンツ生成
      id = 'performanceDialog';
      // タイトル
      switch (marietta.webcad.WebCADGlobal.language) {
        case 'en': title = 'Performance Analyse'; break;
        default: title = 'パフォーマンス分析'; break;
      }
      contents = '<div class="performanceDialog">';
      contents += '<div class="performRow">';
      contents += '<div class="totalScoreContainer">';
      contents += '<div class="totalScoreDiv"><input type="text" value="100%" class="totalPerformanceScore" id="totalPerformanceScore"></div><div class="totalScoreMsg"><span id="scoreMsg">この環境では快適に動作します</span></div>';
      contents += '</div>';
      contents += '</div>';
      contents += '<div class="performRow">';
      contents += '<div class="itemScoreContainer">';
      contents += '<div class="performanceItemTitle"><span>Performance Results</span></div>';
      contents += '<div class="cpuScoreContainer itemScoreChild">';
      contents += '<i id="CPUArrow">&raquo;</i>';
      contents += '<div class="cpuScoreTitle itemScoreFirstCol">処理能力<br>';
      contents += '<span id="cpuScoreValue" class="cpuScoreValue itemScoreSecondCol"></span>';
      contents += '</div>';
      contents += '<div class="itemScoreThirdCol"><div class="progress"><div id="cpuProgress" class="progress-bar cpuProgress"></div></div>';
      contents += '<div class="itemScoreSubTitle cpuScoreSubTitle">CPUの処理能力を計測しました。</div>';
      contents += '</div>';
      contents += '</div>';
      contents += '<div class="browserScoreContainer itemScoreChild">';
      contents += '<i id="browserArrow">&raquo;</i>';
      contents += '<div class="browserScoreTitle itemScoreFirstCol">ブラウザ<br>';
      contents += '<span id="browserScoreValue" class="browserScoreValue itemScoreSecondCol"></span>';
      contents += '</div>';
      contents += '<div class="itemScoreThirdCol"><div class="progress"><div id="browserProgress" class="progress-bar browserProgress"></div></div>';
      contents += '<div class="itemScoreSubTitle browserScoreSubTitle">推奨ブラウザはChromeです。</div>';
      contents += '</div>';
      contents += '</div>';
      contents += '<div class="gpuScoreContainer itemScoreChild">';
      contents += '<i id="GPUArrow">&raquo;</i>';
      contents += '<div class="gpuScoreTitle itemScoreFirstCol">GPU<br>';
      contents += '<span id="gpuScoreValue" class="gpuScoreValue itemScoreSecondCol"></span>';
      contents += '</div>';
      contents += '<div class="itemScoreThirdCol"><div class="progress"><div id="gpuProgress" class="progress-bar gpuProgress"></div></div>';
      contents += '<div class="itemScoreSubTitle gpuScoreSubTitle">グラフィックボードの性能を計測しました</div>';
      contents += '</div>';
      contents += '</div>';
      contents += '<div class="webglScoreContainer itemScoreChild">';
      contents += '<i id="WebGLArrow">&raquo;</i>';
      contents += '<div class="webglScoreTitle itemScoreFirstCol">WebGL<br>';
      contents += '<span id="webglScoreValue" class="webglScoreValue itemScoreSecondCol"></span>';
      contents += '</div>';
      contents += '<div class="itemScoreThirdCol"><div class="progress"><div id="webglProgress" class="progress-bar webglProgress"></div></div>';
      contents += '<div class="itemScoreSubTitle webglScoreSubTitle">対応WebGLの性能を計測しました。</div>';
      contents += '</div>';
      contents += '</div>';
      contents += '</div>';
      contents += '<div class="performRow">';
      contents += '<div class="performanceNotShowDiv" id="performanceNotShowDiv"><input type="checkbox" name="checkPerformanceDisplay" id="checkPerformanceDisplay"><label id="checkPerformanceDisplayLabel">起動時にパフォーマンスチェックを行わない</label></div>';
      contents += '</div>';
      contents += '</div>';

      contents += '</div>';
      footer = '<button id="btnDonePerformanceDisplay"><span class="jp">閉じる</span><span class="en">Close</span></button>';

      this.createDialog(id, title, contents, footer);
      $('.totalPerformanceScore').knob(
        {
          min: 0,
          max: 100,
          readOnly: true,
          width: 140,
          height: 140,
          thickness: 0.20,
          fgColor: '#39b54a',
          inputColor: '#6f6f6f',
          bgColor: '#e8e8e8',
          format(value) {
            return `${value}%`;
          },
        },
      );
      id = null;
      title = null;
      contents = null;
      footer = null;

      /* -----PerformanceCheckFlagの値を割り当てる start here----*/
      // ブラウザのlocalStorage値のチェック条件が存在するかどうか
      // localStorageに基づいてPerformanceCheckチェックボックスのハンドルをチェック/チェック解除します
      if (localStorage.getItem('notShowPerformance') === '1') {
        (<HTMLInputElement>document.getElementById('checkPerformanceDisplay')).checked = true;
        this._showPerformanceFlag = true;
      } else {
        (<HTMLInputElement>document.getElementById('checkPerformanceDisplay')).checked = false;
        this._showPerformanceFlag = false;
      }
      /* -----PerformanceCheckFlagの値を割り当てる end here----*/

      // イベント設定
      // OKButtonクリックをトリガー
      const btn = document.querySelector('#btnDonePerformanceDisplay');
      btn.addEventListener('click', this.btnEventHandler);
      // closeButtonクリックをトリガー

      // ShowPerformanceチェックボックスのクリックハンドル
      const showCheck = document.querySelector('#checkPerformanceDisplay');
      showCheck.addEventListener('click', this.showPerformanceCheckClicked);
      const triggerCheckboxClick = document.querySelector('#checkPerformanceDisplayLabel');
      triggerCheckboxClick.addEventListener('click', this.triggerCheckboxClick);

      // お掃除
      id = null;
      title = null;
      contents = null;
      footer = null;
    }

    /**
     * PerformanceCheckチェックボックスクリックの処理
     * チェック/チェック解除に基づいてPerformanceCheckFlagを設定します
     * @return void
     * @param e => mouse event
    */
    showPerformanceCheckClicked = () => {
      const notShow = (<HTMLInputElement>document.getElementById('checkPerformanceDisplay')).checked;
      if (notShow) {
        this._showPerformanceFlag = true;
      } else {
        this._showPerformanceFlag = false;
      }
    }

    /**
     * ラベルクリックでトリガーチェックボックスクリック
     * @return void
     * @param e => mouse event
    */
    triggerCheckboxClick = () => {
      const triggrt = (<HTMLInputElement>document.getElementById('checkPerformanceDisplay'));
      triggrt.click();
    }

    setMode = () => {
      //const lidarTest = marietta.WebCADGlobal.DEBUG_MODE && (location.href.indexOf('localhost') > -1);
      if (marietta.webcad.WebCADGlobal.webcad2Dmanager.hasLiDAR == true && marietta.webcad.WebCADGlobal.webcad2Dmanager.hasWebCAD == false) {
        if (!marietta.webcad.WebCADGlobal.webcad2Dmanager.isViewMode()) {
          marietta.webcad.WebCADGlobal.showDialog(marietta.webcad.view.dialog.LiDARLogingDialog);
        }
      } else {
        // 新規作成かつ戸建てモード・マンションモードの設定がない場合はモード設定ダイアログを表示する。
        if (Number.isNaN(Number(marietta.webcad.WebCADGlobal.webcad2Dmanager.buildingType)) && !marietta.webcad.WebCADGlobal.webcad2Dmanager.planID) {
          Main.setBuildingStyleFromQueryParameterCondition();
        }
      }
    }
    /**
     * OKボタンがクリックされた
     * パフォーマンスチェッカーの可視性の処理
     * @return void
     * @param e => mouse event
    */
    btnEventHandler = (e: any) => {
      e.preventDefault();

      // performanceLoaderの表示/非表示の処理
      if (this._showPerformanceFlag) {
        // ブラウザのlocalStorageでshowPerformanceを設定します
        this._storage.setItem('notShowPerformance', '1');
      } else {
        // ブラウザのlocalStorageでshowPerformanceを設定します
        this._storage.setItem('notShowPerformance', '0');
      }
      // パネルを閉じる
      marietta.webcad.WebCADGlobal.removeDialog();

      this.setMode();
    }

    close = () => {
      this.closeEvent();
      this.setMode();
      marietta.webcad.WebCADGlobal.webcad2Dmanager.saveToHistory();
    }
}
